import React from "react";
import { CheckCircle2, ShieldAlert } from "lucide-react";

export const CHECKLIST_ITEMS = [
  ["vaccinations_given", "Vaccinations up-to-date (BCG, HepB, OPV as per protocol)"],
  ["hearing_screen_done", "Hearing screen (OAE / BERA) completed"],
  ["rop_screen_done", "ROP screening completed / not indicated"],
  ["car_seat_test", "Car-seat challenge (if applicable)"],
  ["feeding_established", "Feeding adequately established"],
  ["parent_education", "Parent education & red-flag counselling done"],
  ["follow_up_scheduled", "Follow-up appointment scheduled"],
  ["medications_dispensed", "Take-home medications dispensed"],
];

export default function DischargeChecklist({ checklist, onToggle }) {
  const completed = CHECKLIST_ITEMS.filter(([k]) => checklist[k]).length;
  const total = CHECKLIST_ITEMS.length;
  const ready = completed === total;

  return (
    <div className={`card-clinical p-5 border-l-4 ${ready ? "border-l-emerald-500" : "border-l-amber-500"}`}>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-3">
          <div className={`h-10 w-10 rounded-xl grid place-items-center ${ready ? "bg-vacant" : "bg-warn"}`}>
            {ready ? <CheckCircle2 size={20} /> : <ShieldAlert size={20} />}
          </div>
          <div>
            <div className="font-medium">Discharge readiness checklist</div>
            <div className="text-xs text-muted-foreground">
              {ready
                ? "All items complete — safe to finalise."
                : "Optional safety check — highlights any step still pending. You can preview / print / finalise at any time."}
            </div>
          </div>
        </div>
        <div className="text-xs">
          <span className={`font-mono tabular font-semibold ${ready ? "status-vacant" : "status-warn"}`}>
            {completed}/{total}
          </span>
          <span className="text-muted-foreground"> items</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {CHECKLIST_ITEMS.map(([k, l]) => (
          <label
            key={k}
            className={`flex items-start gap-3 rounded-lg px-3 py-2 border transition-colors cursor-pointer ${
              checklist[k] ? "border-emerald-500/40 bg-emerald-500/5" : "border-border hover:border-primary/40"
            }`}
          >
            <input
              type="checkbox"
              checked={!!checklist[k]}
              onChange={() => onToggle(k)}
              className="mt-0.5 h-4 w-4 accent-emerald-500"
              data-testid={`chk-${k}`}
            />
            <span className="text-sm">{l}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
